import { ApiProperty } from '@nestjs/swagger';
import { IsOptional, IsString, MaxLength } from 'class-validator';

/**
 * DTO for rejecting a deal, optionally with a reason.
 */
export class DealRejectionRequest {
  @ApiProperty({
    description: 'Optional reason for rejecting the deal',
    example: 'Unavailable during requested dates',
    required: false,
    maxLength: 500,
  })
  @IsOptional()
  @IsString()
  @MaxLength(500)
  description?: string;
}
